import { Crisp } from "crisp-sdk-web";
var chatPopupOpen = false;
var yourGPTiInitialized = false;
export const loadYourGPT = async () => {
  // load yourgpt script
  const script = document.createElement("script");
  if (!process.env.REACT_APP_YOURGPT_ID) {
    return Promise.reject("YourGPT ID is not defined");
  }
  script.setAttribute("data-widget", process.env.REACT_APP_YOURGPT_ID);
  script.setAttribute("id", "yourgpt-chatbot");
  script.src = "https://widget.yourgpt.ai/script.js";
  script.async = true;
  document.body.appendChild(script);
  return new Promise((resolve, reject) => {
    script.onload = () => {
      // hide button - since no proper api to hide button
      const style = document.createElement("style");
      style.innerHTML = `
        .ygpts-widgetBtnOuter {
        display: none !important;
        }
        .homeQueryTextArea{
        display: none !important;
        }
      `;
      document.head.appendChild(style);
      // wait for initialization
      window.$yourgptChatbot &&
        window.$yourgptChatbot.on("init", () => {
          yourGPTiInitialized = true;
        });
      return resolve();
    };
    script.onerror = () => {
      return reject("YourGPT script failed to load");
    };
  });
};

export const getYourGPT = async () => {
  // wait for yourgpt to load and return the instance
  if (window.$yourgptChatbot && yourGPTiInitialized) {
    return Promise.resolve(window.$yourgptChatbot);
  } else {
    return new Promise((resolve, reject) => {
      let maxTimeout;
      const checkInterval = setInterval(async () => {
        if (window.$yourgptChatbot && yourGPTiInitialized) {
          clearInterval(checkInterval);
          maxTimeout && clearTimeout(maxTimeout);
          resolve(window.$yourgptChatbot);
        }
      }, 100);

      maxTimeout = setTimeout(() => {
        clearInterval(checkInterval);
        console.error("YourGPT instance failed to load");
        reject("YourGPT instance failed to load");
      }, 15000); // Timeout after 10 seconds
    });
  }
};
export const toggleChat = async () => {
  // do not delete
  if (Crisp.chat.isChatOpened()) Crisp.chat.close();
  else {
    // window.$crisp && window.$crisp.push(["do", "overlay:open"]); // overlay method is not available in npm package
    Crisp.chat.open();
  }
  // yourgpt
  // const yourGPT = await getYourGPT();
  // if (!yourGPT) return;

  // if (!chatPopupOpen) {
  //   yourGPT.execute("widget:open");
  // } else {
  //   yourGPT.execute("widget:close");
  // }
};

export const chatConfig = async () => {
  // do not delete
  // usually called at router level
  try {
    Crisp.configure(process.env.REACT_APP_CRISP_WEBSITE_ID);
    Crisp.setSafeMode(true);
    Crisp.chat.hide();
    Crisp.chat.onChatClosed(() => {
      Crisp.chat.hide();
    });
    Crisp.chat.onChatOpened(() => {
      Crisp.chat.show();
    });
    Crisp.message.onMessageReceived(() => {
      Crisp.chat.open();
    });
    // Crisp.user.setEmail(username);
  } catch (error) {
    // catch any issues with crisp
  }
  // await loadYourGPT();
  // const yourGPT = await getYourGPT();
  // yourGPT &&
  //   yourGPT.on("widget:popup", (val) => {
  //     chatPopupOpen = val;
  //     const yourgptButton = document.querySelector(".ygpts-widgetBtnOuter");
  //     if (!yourgptButton) return;
  //     if (val) {
  //       yourgptButton.style.setProperty("display", "block", "important");
  //     } else {
  //       yourgptButton.style.setProperty("display", "none", "important");
  //     }
  //   });
};

export const chatSetVisitorID = async ({ useremail, username }) => {
  // do not delete
  Crisp.user.setEmail(useremail);
  // const yourGPT = await getYourGPT();
  // try {
  //   yourGPT &&
  //     yourGPT.set("contact:data", {
  //       email: useremail,
  //       name: username
  //       // ext_user_id: "123456"
  //     });
  // } catch (error) {
  //   console.error("Error setting visitor ID", error);
  // }
};

export const chatSetVisitorData = async ({ planId, platform }) => {
  // do not delete
  Crisp.session.setData({
    "user-plan-id": planId,
    platform: platform
  });
  // const yourGPT = await getYourGPT();

  // yourGPT &&
  //   yourGPT.set("visitor:data", {
  //     "user-plan-id": planId,
  //     platform: platform
  //   });
};

// export const loadYourGpt = () => {
//   // create script and load from url

// }
